import React, { useEffect, useState } from 'react';
import { Navbar } from '../components/Navbar';
import { SellWithUs } from '../components/SellWithUs';
import { Footer } from '../components/Footer';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../components/auth/AuthProvider';
import { AuthModal } from '../components/auth/AuthModal';
export const SellWithUsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isAuthenticated,
    demoLogin
  } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authModalMode, setAuthModalMode] = useState<'signin' | 'signup'>('signup');
  const [redirectTo, setRedirectTo] = useState<string | undefined>(undefined);
  // Check if demo login is enabled
  const isDemoEnabled = Boolean(demoLogin);
  // Check if we should open auth modal from navigation state
  useEffect(() => {
    const state = location.state as any;
    if (state?.openAuth) {
      setAuthModalMode(state?.initialMode || 'signup');
      setRedirectTo(state?.redirectTo);
      setAuthModalOpen(true);
      // Clear the state to prevent reopening on refresh
      navigate(location.pathname, {
        replace: true,
        state: {}
      });
    }
  }, [location, navigate]);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);
  const handleStartSelling = () => {
    if (isAuthenticated) {
      // If user is already authenticated, redirect to the sell product page
      navigate('/sell-product');
    } else {
      // Otherwise, open auth modal in signup mode with redirect
      setAuthModalMode('signup');
      setAuthModalOpen(true);
    }
  };
  const handleAuthModalClose = () => {
    setAuthModalOpen(false);
  };
  const handleDemoLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isDemoEnabled) {
      console.error('Demo login is disabled');
      return;
    }
    try {
      // Use the demo login function if available
      await demoLogin({
        id: 'demo-seller-123',
        name: 'Demo Seller',
        email: 'demo@example.com',
        roles: ['buyer', 'seller'],
        activeRole: 'seller',
        isSeller: true
      });
      // Redirect to seller dashboard
      navigate('/seller-dashboard');
    } catch (error) {
      console.error('Demo login failed:', error);
      alert('Demo login is disabled. Please sign in with a real account.');
    }
  };
  return <div className="w-full bg-white dark:bg-[#0F1F1D] overflow-x-hidden transition-colors duration-300" data-id="element-6188">
      <Navbar scrolled={scrolled} data-id="element-6189" />
      <main data-id="element-6190">
        <SellWithUs onStartSelling={handleStartSelling} data-id="element-6191" />
        {/* Demo Login Button - Only shown if demo login is enabled */}
        {isDemoEnabled && <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center" data-id="element-6192">
            <div className="inline-block bg-yellow-100 dark:bg-yellow-900/30 border-2 border-yellow-300 dark:border-yellow-700 rounded-lg p-4 mb-8" data-id="element-6193">
              <p className="text-yellow-800 dark:text-yellow-200 font-medium" data-id="element-6194">
                ⚠️ DEMO MODE ENABLED - For testing purposes only
              </p>
            </div>
            <button onClick={handleDemoLogin} className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-bold py-3 px-6 rounded-lg transition-colors duration-200 relative overflow-hidden" data-id="element-6195">
              <span className="absolute top-0 right-0 bg-yellow-400 text-xs text-yellow-900 px-2 py-1 rounded-bl-lg font-bold" data-id="element-6196">
                DEMO
              </span>
              Demo Login (No Firebase Auth)
            </button>
          </div>}
      </main>
      <Footer data-id="element-6197" />
      {/* Auth Modal */}
      <AuthModal isOpen={authModalOpen} onClose={handleAuthModalClose} initialMode={authModalMode} redirectTo={redirectTo || 'submission-form'} data-id="element-6198" />
    </div>;
};